import { z } from "zod"

import { CountryIso3166Schema } from "./enum"

export const prodSiteSchema = z.object({
  name: z.string().trim().regex(new RegExp("[^s]")),
  address: z
    .string({
      error: (issue) =>
        issue.input === undefined ? "Address is required" : undefined,
    })
    .trim()
    .regex(new RegExp("[^s]")),
  countryIso3166: CountryIso3166Schema,
})

export type prodSiteValidationType = z.infer<typeof prodSiteSchema>
